import { useCollaborations } from '@/hooks/useCollaborations'
import MetricsCards from '@/components/performance/MetricsCards'
import ChartSection from '@/components/performance/ChartSection'
import CampaignDetailsTable from '@/components/performance/CampaignDetailsTable'
import { useIsMobile } from '@/hooks/use-mobile'

const Performance = () => {
  const { collaborations } = useCollaborations()
  const isMobile = useIsMobile()

  // Filter active and completed campaigns
  const activeCampaigns = collaborations.filter(
    (campaign) => campaign.waveStatus === 'live' || campaign.waveStatus === 'completed',
  )

  // Calculate total metrics across all campaigns
  const totalViews = activeCampaigns.reduce(
    (total, campaign) => total + (campaign.metrics?.views || 0),
    0,
  )

  const avgEngagement =
    activeCampaigns.length > 0
      ? activeCampaigns.reduce(
          (total, campaign) => total + (campaign.metrics?.engagement || 0),
          0,
        ) / activeCampaigns.length
      : 0

  const avgCompletionRate =
    activeCampaigns.length > 0
      ? activeCampaigns.reduce(
          (total, campaign) => total + (campaign.metrics?.completionRate || 0),
          0,
        ) / activeCampaigns.length
      : 0

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Reporting</h1>
        <p className="text-gray-600">Track your collaboration metrics and analytics</p>
      </div>

      <MetricsCards
        totalViews={totalViews}
        avgEngagement={avgEngagement}
        avgCompletionRate={avgCompletionRate}
      />

      <ChartSection campaigns={activeCampaigns} />

      <CampaignDetailsTable campaigns={activeCampaigns} />
    </div>
  )
}

export default Performance
